<template>
  <v-dialog
    v-model="show"
    :fullscreen="isMobile"
    max-width="450px"
    min-width="100px"
    :style="{ zIndex: options.zIndex }"
    width="50%"
  >
    <v-card class="d-flex flex-column" tile>
      <v-toolbar class="px-3 flex-grow-0" color="primary" dark flat height="60">
        <v-toolbar-title>
          {{ $t(title, options.params) }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <base-button icon small @click="cancel">
          <v-icon>mdi-close</v-icon>
        </base-button>
      </v-toolbar>
      <v-card-text class="flex-grow-1 pa-7">
        <base-form ref="formConfirm" v-model="isvaild" @submit="onSubmit">
          <div>
            <template
              v-for="(message, index) in messages"
              v-show="messages.length > 0"
            >
              <div v-if="message.confirmText" :key="index">
                <p
                  :key="index"
                  class="pa-0 ma-0 "
                  style="color:#092D29"
                  v-html="
                    $t('confirm.text-confirm', { name: message.confirmText })
                  "
                ></p>
                <v-text-field
                  autocomplete="confirm"
                  class=""
                  dense
                  height="30px"
                  hide-details
                  outlined
                  :rules="[(v) => !!v && v == message.confirmText]"
                ></v-text-field>
              </div>
              <p
                v-else-if="message.trans"
                :key="index"
                class="pa-0 ma-0 pb-1"
                style="color:#092D29"
                v-html="$t(message.trans, options.params)"
              ></p>
              <p
                v-else-if="message.title"
                :key="index"
                class="pa-0 ma-0 pb-1"
                style="color:#092D29"
                v-html="message.title"
              >
              </p>
            </template>
          </div>
        </base-form>
      </v-card-text>
      <v-card-actions class="flex-grow-0" style="padding: 0 28px 22px;">
        <v-spacer />
        <v-btn class="mr-2 text-none" text @click="cancel">
          {{ options.noText || $t('actions.no') }}
        </v-btn>
        <v-btn
          class="text-none"
          :color="options.color"
          :disabled="!isvaild"
          @click="agree"
          outlined
        >
          {{ options.yesText || $t('actions.apply') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultOption = {
  color: 'primary',
  width: 600,
  zIndex: 200,
  params: {},
}
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    options: {
      color: 'primary',
      zIndex: 200,
      params: {},
    },
    messages: [],
    isvaild: false,
    form: {},
  }),
  computed: {
    show: {
      get() {
        return this.dialog
      },
      set(value) {
        this.dialog = value
        if (value === false) {
          this.cancel()
        }
      },
    },
  },
  methods: {
    open(title, messages, options) {
      this.show = true
      this.title = title
      if (typeof messages == 'string') {
        this.messages = [{ title: messages }]
      } else {
        this.messages = messages
      }
      this.options = Object.assign({}, defaultOption, options)
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    agree() {
      this.$refs.formConfirm.validate()
      if (this.isvaild) {
        if (Object.keys(this.form).length > 0) {
          this.resolve(this.form)
        } else {
          this.resolve(true)
        }
        this.clear()
      }
    },
    clear() {
      this.title = ''
      this.messages = []
      this.form = {}
      this.options = Object.assign({}, defaultOption)
      this.dialog = false
    },
    cancel() {
      this.clear()
      this.resolve(false)
    },
    onSubmit() {
      if (!this.isvaild) {
        return
      }
      if (this.agree) this.agree()
    },
  },
}
</script>
